module.exports = __webpack_public_path__ + "static/img/sucess.6729a26b.png";